<template>
  <div class="rg-object-icon">
    <unidentified-object v-if="!isShip" v-bind="iconProps" />
    <vessel-course v-else-if="isVesselCourse" v-bind="iconProps" />
    <vessel-course-unknown v-else v-bind="iconProps" />
  </div>
</template>

<script>
import UnidentifiedObject from "../icons/unidentified-object/UnidentifiedObject.vue";
import VesselCourse from "../icons/vessel-course/VesselCourse.vue";
import VesselCourseUnknown from "../icons/vessel-course-unknown/VesselCourseUnknown.vue";
import isObject from "lodash/isObject";
import C from "../../Constants";
const { CAUTION } = C.RG_RISK_LEVEL;

export default {
  name: "RgObjectIcon",
  components: {
    UnidentifiedObject,
    VesselCourse,
    VesselCourseUnknown,
  },
  props: {
    rgRiskLevelManager: {
      type: Object, // RadarGridMixin の RiskLevelManagerResult
      required: true,
      // {
      //   objectIcon: calcObjectIcon(),
      //   frameIconId: calcFrameIconId(),
      //   brinkIconId: calcBrinkIconId(),
      //   hasManualAssessment: boolean,
      //   autoRiskLevel: number,
      //   manualRiskLevel: number
      //   riskLevel: number,
      //   isValidCog: boolean,
      //   isShip: boolean,
      // }
    },
  },

  computed: {
    hasRiskLevelManager() {
      const { rgRiskLevelManager } = this;
      return isObject(rgRiskLevelManager);
    },
    isShip() {
      const { hasRiskLevelManager, rgRiskLevelManager } = this;
      if (!hasRiskLevelManager) return false;
      return rgRiskLevelManager.isShip;
    },
    hasManualAssessment() {
      const { hasRiskLevelManager, rgRiskLevelManager } = this;
      if (!hasRiskLevelManager) return false;
      return rgRiskLevelManager.hasManualAssessment;
    },
    riskLevel() {
      const { hasRiskLevelManager, rgRiskLevelManager } = this;
      if (!hasRiskLevelManager) return CAUTION;
      return rgRiskLevelManager.riskLevel;
    },
    isValidCog() {
      const { hasRiskLevelManager, rgRiskLevelManager } = this;
      if (!hasRiskLevelManager) return false;
      return rgRiskLevelManager.isValidCog;
    },
    isVesselCourse() {
      const { isShip, isValidCog } = this;
      return isShip && isValidCog;
    },
    iconProps() {
      const { hasManualAssessment, riskLevel } = this;
      return { hasManualAssessment, riskLevel };
    },
  },
};
</script>
